import { Navigate } from "react-router-dom";
import Layout from "../Layout";
import { useAppSelector } from "../../hooks/useAppHooks";
import ProtectedRoute from "../ProtectedRoute";
import Loading from "../loadingModal/LoadingModal";
import DocLayout from "../DocLayout";

const CustomRoute = ({ adminOnly, component: Component, isProtected, doc }) => {
  const user = useAppSelector((state) => state.usersReducer.userLogged);
  const isLearner = user && user.role === "Learner";
  if (isLearner && adminOnly) {
    return (
      <Navigate
        to="/home"
        replace
        state={{
          errorMessage: "You don't have access to enter to this page.",
        }}
      />
    );
  }

  const element = isProtected ? (
    <ProtectedRoute>
      <Loading />
      <Layout component={Component} isProtected={isProtected} />
    </ProtectedRoute>
  ) : doc ? (
    <DocLayout>
      <Component />
    </DocLayout>
  ) : (
    <Component />
  );

  return element;
};

export default CustomRoute;
